export default "__VITE_ASSET__D_rUmc6E__"